export default __webpack_public_path__ + "static/media/avatar.37d93aaa.jpg";